import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { ErrorBoundary } from '@sentry/nextjs';
import LabradorJwVideoArticle from './Article';
import LabradorJwVideoTeaser from './Teaser';

const LabradorJwVideo: LabradorComponent = ({ data, type, meta, descendants }) => {
  const { enableShop, enableTeaser } = data;
  if (enableShop) return null;

  if (enableTeaser)
    return (
      <ErrorBoundary>
        <LabradorJwVideoTeaser
          data={data}
          type={type}
          meta={meta}
          descendants={descendants}
          {...withDebugMetadata({ type, meta })}
        />
      </ErrorBoundary>
    );

  return (
    <ErrorBoundary>
      <LabradorJwVideoArticle
        data={data}
        type={type}
        meta={meta}
        descendants={descendants}
        {...withDebugMetadata({ type, meta })}
      />
    </ErrorBoundary>
  );
};

export default LabradorJwVideo;
